// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/weather_forecast_point_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { AreaWeatherForecastPoint, AreaWeatherForecastPointCandidates } from "./weather_forecast_point_model_pb";
import { file_bffuser_v1_weather_forecast_point_model } from "./weather_forecast_point_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/weather_forecast_point_service.proto.
 */
export const file_bffuser_v1_weather_forecast_point_service: GenFile = /*@__PURE__*/
  fileDesc("Ci9iZmZ1c2VyL3YxL3dlYXRoZXJfZm9yZWNhc3RfcG9pbnRfc2VydmljZS5wcm90bxIKYmZmdXNlci52MSIiCiBMaXN0V2VhdGhlckZvcmVjYXN0UG9pbnRzUmVxdWVzdCKdAQohTGlzdFdlYXRoZXJGb3JlY2FzdFBvaW50c1Jlc3BvbnNlEjQKBnBvaW50cxgBIAMoCzIkLmJmZnVzZXIudjEuQXJlYVdlYXRoZXJGb3JlY2FzdFBvaW50EkIKCmNhbmRpZGF0ZXMYAiADKAsyLi5iZmZ1c2VyLnYxLkFyZWFXZWF0aGVyRm9yZWNhc3RQb2ludENhbmRpZGF0ZXMizAEKHlVwZGF0ZVdlYXRoZXJGb3JlY2FzdFBvaW50SXRlbRI0CglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZUIKukgHggEEEAEgABIeCg1sb2NhdGlvbl9uYW1lGAIgASgJQge6SARyAhABEjwKE2V4cGVjdGVkX3VwZGF0ZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQFCFgoUX2V4cGVjdGVkX3VwZGF0ZWRfYXQiaQoiVXBkYXRlV2VhdGhlckZvcmVjYXN0UG9pbnRzUmVxdWVzdBJDCgVpdGVtcxgBIAMoCzIqLmJmZnVzZXIudjEuVXBkYXRlV2VhdGhlckZvcmVjYXN0UG9pbnRJdGVtQgi6SAWSAQIIASJbCiNVcGRhdGVXZWF0aGVyRm9yZWNhc3RQb2ludHNSZXNwb25zZRI0CgZwb2ludHMYASADKAsyJC5iZmZ1c2VyLnYxLkFyZWFXZWF0aGVyRm9yZWNhc3RQb2ludDKcAgobV2VhdGhlckZvcmVjYXN0UG9pbnRTZXJ2aWNlEnoKGUxpc3RXZWF0aGVyRm9yZWNhc3RQb2ludHMSLC5iZmZ1c2VyLnYxLkxpc3RXZWF0aGVyRm9yZWNhc3RQb2ludHNSZXF1ZXN0Gi0uYmZmdXNlci52MS5MaXN0V2VhdGhlckZvcmVjYXN0UG9pbnRzUmVzcG9uc2UiABKAAQobVXBkYXRlV2VhdGhlckZvcmVjYXN0UG9pbnRzEi4uYmZmdXNlci52MS5VcGRhdGVXZWF0aGVyRm9yZWNhc3RQb2ludHNSZXF1ZXN0Gi8uYmZmdXNlci52MS5VcGRhdGVXZWF0aGVyRm9yZWNhc3RQb2ludHNSZXNwb25zZSIAQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bfftypes_v1_area, file_bffuser_v1_weather_forecast_point_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * ListWeatherForecastPointsRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListWeatherForecastPointsRequest
 */
export type ListWeatherForecastPointsRequest = Message<"bffuser.v1.ListWeatherForecastPointsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListWeatherForecastPointsRequest.
 * Use `create(ListWeatherForecastPointsRequestSchema)` to create a new message.
 */
export const ListWeatherForecastPointsRequestSchema: GenMessage<ListWeatherForecastPointsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_point_service, 0);

/**
 * @generated from message bffuser.v1.ListWeatherForecastPointsResponse
 */
export type ListWeatherForecastPointsResponse = Message<"bffuser.v1.ListWeatherForecastPointsResponse"> & {
  /**
   * Effective point for all 10 areas (AC-WFP-007). Areas that have not been
   * configured yet carry the area default with updated_at absent and
   * selection_state = DEFAULT_UNSET.
   *
   * @generated from field: repeated bffuser.v1.AreaWeatherForecastPoint points = 1;
   */
  points: AreaWeatherForecastPoint[];

  /**
   * System-fixed candidate lists, one entry per area (10 total).
   * Ordered with the recommended default at index 0.
   *
   * @generated from field: repeated bffuser.v1.AreaWeatherForecastPointCandidates candidates = 2;
   */
  candidates: AreaWeatherForecastPointCandidates[];
};

/**
 * Describes the message bffuser.v1.ListWeatherForecastPointsResponse.
 * Use `create(ListWeatherForecastPointsResponseSchema)` to create a new message.
 */
export const ListWeatherForecastPointsResponseSchema: GenMessage<ListWeatherForecastPointsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_point_service, 1);

/**
 * UpdateWeatherForecastPointItem carries the desired selection for a
 * single area.
 *
 * @generated from message bffuser.v1.UpdateWeatherForecastPointItem
 */
export type UpdateWeatherForecastPointItem = Message<"bffuser.v1.UpdateWeatherForecastPointItem"> & {
  /**
   * Target area. UNSPECIFIED is rejected.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * The selected point name. Must be a non-empty string that appears in
   * the system-fixed candidate list for area_code (validated by the
   * backend usecase; proto enforces non-empty only).
   *
   * @generated from field: string location_name = 2;
   */
  locationName: string;

  /**
   * Optimistic-lock baseline. Must match the stored updated_at of the
   * existing row; absent when no record exists yet for this area (= new
   * insert). The server returns ABORTED when the baseline differs from
   * the stored value (AC-WFP-005).
   *
   * @generated from field: optional google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateWeatherForecastPointItem.
 * Use `create(UpdateWeatherForecastPointItemSchema)` to create a new message.
 */
export const UpdateWeatherForecastPointItemSchema: GenMessage<UpdateWeatherForecastPointItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_point_service, 2);

/**
 * UpdateWeatherForecastPointsRequest updates one or more areas in a
 * single atomic transaction.
 *
 * @generated from message bffuser.v1.UpdateWeatherForecastPointsRequest
 */
export type UpdateWeatherForecastPointsRequest = Message<"bffuser.v1.UpdateWeatherForecastPointsRequest"> & {
  /**
   * Items to update. At least one item is required.
   *
   * @generated from field: repeated bffuser.v1.UpdateWeatherForecastPointItem items = 1;
   */
  items: UpdateWeatherForecastPointItem[];
};

/**
 * Describes the message bffuser.v1.UpdateWeatherForecastPointsRequest.
 * Use `create(UpdateWeatherForecastPointsRequestSchema)` to create a new message.
 */
export const UpdateWeatherForecastPointsRequestSchema: GenMessage<UpdateWeatherForecastPointsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_point_service, 3);

/**
 * @generated from message bffuser.v1.UpdateWeatherForecastPointsResponse
 */
export type UpdateWeatherForecastPointsResponse = Message<"bffuser.v1.UpdateWeatherForecastPointsResponse"> & {
  /**
   * Full effective area state after the update has been applied (all 10
   * areas), same shape as the List response.
   *
   * @generated from field: repeated bffuser.v1.AreaWeatherForecastPoint points = 1;
   */
  points: AreaWeatherForecastPoint[];
};

/**
 * Describes the message bffuser.v1.UpdateWeatherForecastPointsResponse.
 * Use `create(UpdateWeatherForecastPointsResponseSchema)` to create a new message.
 */
export const UpdateWeatherForecastPointsResponseSchema: GenMessage<UpdateWeatherForecastPointsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_point_service, 4);

/**
 * WeatherForecastPointService provides Connect RPCs for viewing and
 * editing the weather-forecast point selection per area
 * (エリア別気象予測地点設定).
 *
 * Mutations use per-row optimistic locking via expected_updated_at.
 * A single UpdateWeatherForecastPoints call updates all supplied areas
 * atomically (AC-WFP-004): any conflict or validation failure rolls back
 * every item in the batch.
 *
 * @generated from service bffuser.v1.WeatherForecastPointService
 */
export const WeatherForecastPointService: GenService<{
  /**
   * ListWeatherForecastPoints returns the *effective* point for all 10 areas
   * (AC-WFP-007: the saved selection when it is still a candidate, otherwise
   * the area default; selection_state says which) together with the
   * system-fixed candidate list per area. The frontend renders location_name
   * as-is and does not re-derive the fallback.
   * organization_id is resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.WeatherForecastPointService.ListWeatherForecastPoints
   */
  listWeatherForecastPoints: {
    methodKind: "unary";
    input: typeof ListWeatherForecastPointsRequestSchema;
    output: typeof ListWeatherForecastPointsResponseSchema;
  },
  /**
   * UpdateWeatherForecastPoints updates the weather-forecast point
   * selection for one or more areas in a single atomic transaction
   * (AC-WFP-004). Optimistic locking is applied per row via
   * expected_updated_at: if the stored updated_at differs from the
   * baseline the server returns ABORTED (AC-WFP-005). A location_name that
   * is not in the system-fixed candidate list is rejected with
   * INVALID_ARGUMENT (AC-WFP-009). organization_id is resolved by the BFF
   * handler from eauth.
   *
   * @generated from rpc bffuser.v1.WeatherForecastPointService.UpdateWeatherForecastPoints
   */
  updateWeatherForecastPoints: {
    methodKind: "unary";
    input: typeof UpdateWeatherForecastPointsRequestSchema;
    output: typeof UpdateWeatherForecastPointsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_weather_forecast_point_service, 0);

